import { NeoState } from '../Reducers.interface';

export const selectCustomerList = (state: NeoState) => state.customers.list.customers;

export const SelectCustomerListUntilCurrentPage = (state: NeoState) =>
  selectCustomerList(state).filter(
    (customer) => customer.pageNumber && customer.pageNumber <= state.customers.list.currentPage,
  );

export const selectCustomerListCurrentPageSize = (state: NeoState) => state.customers.list.pageSize;

export const selectCustomer = (customerId: string) => (state: NeoState) => {
  const customer = state.customers.list.customers.find((customer) => customer.uuid === customerId);

  return customer || null;
};
